<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">AP-Check Logs</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="width: auto">
            <div class="row" style="margin-bottom: 12px">
                <div class="col-md-12">
                    <nz-select [(ngModel)]="searchField" style="width: auto">
                        @for (field of searchFields; track field) {
                            <nz-option [nzValue]="field.value" [nzLabel]="field.label"></nz-option>
                        }
                    </nz-select>
                    <input
                        nz-input
                        [(ngModel)]="searchValue"
                        placeholder="Enter search criteria..."
                        style="width: 200px"
                        (keydown.enter)="onSearch()" />
                    <button nz-button nzType="primary" (click)="onSearch()">Search</button>
                    <button nz-button (click)="clearSearch()">Reset</button>
                </div>
            </div>
            <div class="row" style="margin-bottom: 12px">
                <div class="col-md-12">
                    <label class="control-label" for="logType">Log Type</label>
                    <nz-radio-group
                        name="logType"
                        [(ngModel)]="logType"
                        nzButtonStyle="solid"
                        nzSize="small"
                        (ngModelChange)="onLogTypeChange($event)">
                        <label for="logType" name="logType" nz-radio-button [nzValue]="'all'">All</label>
                        <label for="logType" name="logType" nz-radio-button [nzValue]="0">User</label>
                        <label for="logType" name="logType" nz-radio-button [nzValue]="1">Application</label>
                    </nz-radio-group>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px">
                <div class="col-md-5" style="width: auto">
                    <label class="control-label" for="startDate">Begin</label>
                    <nz-date-picker
                        type="date"
                        nzId="startDate"
                        name="startDate"
                        [nzShowTime]="dtpBeginOptions"
                        nzFormat="yyyy-MM-dd h:mm:ss a"
                        [(ngModel)]="startDate"
                        (ngModelChange)="onStartDateChange($event)"></nz-date-picker>
                </div>
                <div class="col-md-5" style="width: auto">
                    <label class="control-label" for="endDate">End</label>
                    <nz-date-picker
                        type="date"
                        nzId="endDate"
                        name="endDate"
                        [nzShowTime]="dtpEndOptions"
                        nzFormat="yyyy-MM-dd h:mm:ss a"
                        [(ngModel)]="endDate"
                        (ngModelChange)="onEndDateChange($event)"></nz-date-picker>
                </div>
                <div class="col-md-2 pull-right">
                    @if (total > 0) {
                        <button class="pull-right" nz-button [nz-tooltip]="'Export'" (click)="onExport()">
                            <nz-icon nzType="file-excel" nzTheme="fill" />Export
                        </button>
                    }
                </div>
            </div>
        </div>
        <nz-table
            #logTable
            [nzData]="logs"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead style="border: 1px solid black">
                <tr>
                    @for (column of columns; track column) {
                        <th
                            [nzShowSort]="column.compare"
                            [nzSortFn]="column.compare"
                            [nzWidth]="column.width ? column.width : ''"
                            [nzColumnKey]="column.fieldName"
                            [nzSortOrder]="getSortOrder(column.fieldName)">
                            {{ column.title }}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of logs; track data.LogId) {
                    <tr>
                        <td style="text-align: center">{{ data.LogDate + "Z" | date: "yyyy-MM-dd hh:mm:ss a" }}</td>
                        <td style="text-align: center">{{ data.UserName }}</td>
                        <td style="text-align: center">{{ getTypeName(data.LogType) }}</td>
                        <td>
                            {{ data.Message }}
                        </td>
                        <td>
                            {{ data.Info }}
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
        <div class="pull-right">
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </div>
    </div>
</div>
